<div class="text-subtext-column" [ngClass]="{ 'pb-1': isMobile }">
  <div class="flex flex-row items-center gap-[0.2em]">

    <div class="flex flex-col">

      <div [ngClass]="textSubText?.hasClass ? 'text-base font-normal leading-tight' : ''">
        {{ textSubText?.text }}
      </div>

      <div [ngClass]="textSubText?.hasClass ? 'text-sm font-normal text-gray-500 leading-snug' : ''">
        {{ textSubText?.subText }}
      </div>

    </div>
  </div>
</div>